import React from 'react';
import { Title, Content, DialogActions } from 'ui/views/dialogs/Dialog';
import { List, FormControl, RadioGroup } from '@mui/material';
import Button from 'ui/elements/buttons/Button';
import { PostTo } from '../types';
import { VisibilityOption } from './VisibilityOption';
import styled from '@emotion/styled';
import { bluePlanetTheme } from 'ui/theme';
import FontRedHat from 'ui/theme/FontRedHat';
import { fontSizeMedium } from 'ui/theme/themeBluePlanet';
import { halfSpacing } from 'ui/theme/themeConstants';

export function getValue(postTo: PostTo) {
  return (
    postTo.type + ('visibility' in postTo ? postTo.visibility : '') + ('profile' in postTo ? postTo.profile.id : '')
  );
}

const VisibilityGroupHeading = styled.div`
  font-weight: ${bluePlanetTheme.typography.fontWeightMedium};
  font-family: ${FontRedHat.text};
  color: ${bluePlanetTheme.bluePlanetPalette.grey.main};
  font-size: ${fontSizeMedium};
  margin-bottom: ${halfSpacing};
  margin-top: ${halfSpacing};
`;

export function VisibilitySelector({
  value,
  options,
  onChange,
  onClose,
  onExtraAction,
  confirmAction,
}: {
  value?: PostTo;
  onClose: () => void;
  options: (PostTo | string)[];
  onChange: (value: PostTo) => void;
  onExtraAction?: () => void;
  confirmAction?: JSX.Element;
}) {
  return (
    <>
      <Title onClose={onClose}>Who are you posting to?</Title>
      <Content>
        <List>
          <FormControl>
            <RadioGroup value={value ? getValue(value) : null}>
              {options.map(option =>
                typeof option === 'string' ? (
                  <VisibilityGroupHeading key={option}>{option}</VisibilityGroupHeading>
                ) : (
                  <VisibilityOption key={getValue(option)} value={option} onChange={onChange} />
                ),
              )}
            </RadioGroup>
          </FormControl>
        </List>
      </Content>
      <DialogActions align="space-between">
        {confirmAction ? (
          confirmAction
        ) : (
          <Button kind="primary" onClick={onClose}>
            Done
          </Button>
        )}
        {onExtraAction && (
          <Button kind="tertiary" onClick={onExtraAction}>
            More options
          </Button>
        )}
      </DialogActions>
    </>
  );
}
